import React from 'react';

type Props = {
    icon: JSX.Element;
    label: string;
    onClick: () => void;
    selected?: boolean;
};

export const MessageButton: React.FC<Props> = ({ icon, label, onClick, selected }) => {
    return (
        <button className={`button message-button${selected ? ' active' : ''}`} onClick={onClick}>
            {icon}
            <span>{label}</span>
        </button>
    );
};
